import React, { useEffect } from "react";

import ClientStats from "shared/util/ClientStats";
import _str from "shared/util/_str";
import Masthead from "./Masthead";
import { ROUTES } from "routers/shared/util/consts";

const SupportOkC = React.forwardRef((_, ref) => {
	useEffect(() => { ClientStats.update("masthead - support okc - rubber_ducky - shown"); }, []);

	return (
		<Masthead ref={ref} id="support_okc_masthead" className="alistpromo opensans rubber_ducky" noClose>
			<div className="support_icon" />
			<div className="text">
				<strong>{_str("Here’s the rub…")}</strong>

				{_str(`
				OkCupid is supported
				by our A-List members, which is
				why they get those awesome perks. Support OkC and enjoy the
				benefits.
			`)}
			</div>
			<a href={`${ROUTES.Upgrade[0]}?cf=desktopbanner`} className="flatbutton green">
				{_str("Join A-List")}
			</a>
		</Masthead>
	);
});

export default SupportOkC;



// WEBPACK FOOTER //
// ./src/routers/Desktop/HeaderBanner/SupportOkC.jsx